module.exports = __webpack_public_path__ + "img/wind_g.0daaabdf.png";